import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { scaleOrdinal } from 'd3-scale';
import { schemePastel2 } from 'd3-scale-chromatic';
import dt from '../../../shared/theme';

const d = 40;
const dimension = css`
  height: ${d}px;
  width: ${d}px;
  border-radius: 4px;
`;

const Img = styled.img`
  ${dimension};
  background-color: transparent;
`;

const Letter = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  ${dimension};
  background-color: ${props => props.bg};

  > span {
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${d * 2}px;
    width: ${d * 2}px;
    transform: scale(0.5);
    color: white;
    font: ${props => dt(props).theme.fontWeightDccc} ${32 * 2}px/100% ${props => dt(props).theme.fontFamilyBody};
  }
`;

const color = scaleOrdinal(schemePastel2);

export default function Avatar({
  profilePictureUrl, profileUrl, name,
}) {
  if (profilePictureUrl) {
    return profileUrl
      ? (
        <a href={profileUrl} className="avatar" tabIndex={0}>
          <Img src={profilePictureUrl} alt={name} />
        </a>
      )
      : <Img className="avatar" src={profilePictureUrl} alt={name} />;
  }

  const letterProps = {
    bg: color(name),
    className: 'avatar',
    ...(profileUrl ? { href: profileUrl } : {}),
  };

  return (
    <Letter {...letterProps}>
      <span>{name.charAt(0)}</span>
    </Letter>
  );
}

Avatar.propTypes = {
  profilePictureUrl: PropTypes.string,
  profileUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
};
Avatar.defaultProps = {
  profilePictureUrl: null,
  profileUrl: null,
};
